import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';

import AutomaticStateTransitionListBrowser from './AutomaticStateTransitionListBrowser';
import HeaderLinks from './header/HeaderLinks';
import HeaderTitle from './header/HeaderTitle';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_AUTOMATIC_STATE_TRANSITIONS } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const onAdd = () => {
    historyContext.push(`/automaticStateTransitions/new`);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <HeaderTitle />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_AUTOMATIC_STATE_TRANSITIONS} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_AUTOMATIC_STATE_TRANSITIONS}>
        <AutomaticStateTransitionListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
